module.exports = __webpack_public_path__ + "static/media/HighlightGoodOptimized.90646167.jp2";